import { API_URL } from '../config/api';

/**
 * Track when a user clicks on a phone number to call
 * @param {string} page - The page name where the call was initiated
 * @param {string} section - The section/component (e.g., 'header', 'footer', 'floating-cta')
 */
export const trackCall = async (page, section) => {
  try {
    await fetch(`${API_URL}/api/call-tracking/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: page || window.location.pathname,
        section,
        timestamp: new Date().toISOString(),
        referrer: document.referrer || null
      })
    });
  } catch (error) {
    // Silent fail - don't interrupt user experience
    console.log('Call tracking error:', error);
  }
};

/**
 * Wrapper for phone links that tracks clicks
 * @param {string} section - The section identifier
 * @returns {function} Click handler
 */
export const handleCallClick = (section) => {
  return () => {
    trackCall(window.location.pathname, section);
  };
};
